import React, { useEffect, useMemo, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  SUSPEND, ShowError, confirmationDialog, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_STATUS, ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY,  
  StatusSimpleOptions, JSON_KEY_SUBMITTER, NO, JSON_KEY_WITHDRAW_ALL_ORDERS,
  INSTRUMENT_TYPE_CRYPTO, INSTRUMENT_TYPE_EQUITY, INSTRUMENT_TYPE_ETF, INSTRUMENT_TYPE_FUTURES, INSTRUMENT_TYPE_INDEX,
  INSTRUMENT_TYPE_WARRANT, 
  INSTRUMENT_TYPE_NAME_ETF, INSTRUMENT_TYPE_NAME_EQUITY, INSTRUMENT_TYPE_NAME_CRYPTO, INSTRUMENT_TYPE_NAME_CURRENCY,
//   INSTRUMENT_TYPE_NAME_BONDS, INSTRUMENT_TYPE_NAME_WARRANT, INSTRUMENT_TYPE_NAME_INDEX, INSTRUMENT_TYPE_NAME_FUTURES, 
  INSTRUMENT_TYPE_BONDS, INSTRUMENT_TYPE_CURRENCY,
  JSON_KEY_MARKET, JSON_KEY_BASE, JSON_KEY_PRICE_DECIMALS, JSON_KEY_INSTRUMENT_TYPE, EVENT_TYPE_INSTRUMENT_STATUS,
  EVENT_TYPE_INSTRUMENT_CREATE, JSON_KEY_CURRENCY, JSON_KEY_QTY_DECIMALS, JSON_KEY_REFERENCE_PRICE,
  JSON_KEY_PREVIOUS_PRICE, JSON_KEY_OPEN, JSON_KEY_CLOSE, JSON_KEY_INSTRUMENT, JSON_KEY_DESCRIPTION,
  ITEM_CANCEL, ITEM_TRADE_ENTRY,
  JSON_KEY_BUY_USER,
  JSON_KEY_BUY_TRADING_ACCOUNT,
  JSON_KEY_SELL_USER,
  JSON_KEY_SELL_TRADING_ACCOUNT,
  GetMinStep,
  PRICE_DECIMALS,
  QTY_DECIMALS,
  JSON_KEY_PRICE,
  JSON_KEY_QTY,
  JSON_KEY_ISSUE_QTY,
  ConvertStatusFromNameToId,
  ConvertStatus,
  STATUS_ACTIVE,
  JSON_KEY_UPDATE_STATS,
  JSON_KEY_TRADING_RULES,
  INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY,
  INSTRUMENT_TYPE_CRYPTO_CURRENCY,
  EVENT_TYPE_INSTRUMENT_CANCEL_ALL_ORDERS,
  EVENT_TYPE_INSTRUMENT_MODIFY,
  ConfirmConfirmCancelAndSubmit,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { makeGetCellValue, selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_INSTRUMENT_CANCEL_ALL_ORDERS, MSG_TYPE_INSTRUMENT_CHANGE_STATUS, MSG_TYPE_INSTRUMENT_CREATE, MSG_TYPE_INSTRUMENT_MODIFY, MSGTYPE_TRADE_ENTRY } from "../../common/msg_types";
import { ConvertToInstrumentTypeId, yesNoOptions } from "../../common/convert_functions";
import { RenderDropdown, To64BitIntFromPriceString, CleanNumber, InputMediumField } from "../../common/utilies";
import { selectAccounts, selectTradingUsers } from "../../redux/dropDownSlice";

const InstrumentsAdminForm = ({ rowData, onClose, allInstrumentsOptions, instrumentOptions, marketOptions, currencyOptions, tradingRulesOptions }) => {

   const typeOptions = useMemo(() => ([
      { id: INSTRUMENT_TYPE_CRYPTO, name: INSTRUMENT_TYPE_NAME_CRYPTO },
      { id: INSTRUMENT_TYPE_CRYPTO_CURRENCY, name: INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY },
      { id: INSTRUMENT_TYPE_CURRENCY, name: INSTRUMENT_TYPE_NAME_CURRENCY },
      { id: INSTRUMENT_TYPE_EQUITY, name: INSTRUMENT_TYPE_NAME_EQUITY },
      { id: INSTRUMENT_TYPE_ETF, name: INSTRUMENT_TYPE_NAME_ETF },
   ]), []);

   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // Dropdown/shared state
   const [code, setCode] = useState(rowData?.code);
   const [status, setStatus] = useState(SUSPEND);
   const [type, setType] = useState(DROPDOWN_LIST_NONE);
   const [priceDecimals, setPriceDecimals] = useState(CleanNumber(rowData?.price_dec));
   const [qtyDecimals, setQtyDecimals] = useState(CleanNumber(rowData?.qty_dec));
   const [issueQty, setIssueQty] = useState(CleanNumber(rowData?.issue));
   const [reference, setReference] = useState(CleanNumber(rowData?.ref));
   const [previous, setPrevious] = useState(CleanNumber(rowData?.prev));
   const [open, setOpen] = useState(CleanNumber(rowData?.open));
   const [close, setClose] = useState(CleanNumber(rowData?.close));
   const [tradingRules, setTradingRules] = useState(rowData?.rules ?? DROPDOWN_LIST_NONE);

   const [description, setDescription] = useState(rowData?.descr ?? '');
   const [base, setBase] = useState(DROPDOWN_LIST_NONE);
   const [currency, setCurrency] = useState(DROPDOWN_LIST_NONE);
   const [market, setMarket] = useState(DROPDOWN_LIST_NONE);
   const [cancelAllOrders, setCancelAllOrders] = useState(NO);

   const [buyTrader, setBuyTrader] = useState(DROPDOWN_LIST_NONE);
   const [sellTrader, setSellTrader] = useState(DROPDOWN_LIST_NONE);
   const [buyTradingAccount, setBuyTradingAccount] = useState(DROPDOWN_LIST_NONE);
   const [sellTradingAccount, setSellTradingAccount] = useState(DROPDOWN_LIST_NONE);
   const dropDownTradingUsersData = useSelector(selectTradingUsers);
   const dropDownTradingAccountsData = useSelector(selectAccounts);
   const [price, setPrice] = useState('');
   const [quantity, setQuantity] = useState('');
   const [updateStats, setUpdateStats] = useState(NO);
   const [qty_step, setQtyStep] = useState(0.0001);
   const [price_step, setPriceStep] = useState(0.0001);
   const getDecimalValue = useMemo(() => makeGetCellValue(), []);
   const price_dec = useSelector((state) => getDecimalValue(state, code, PRICE_DECIMALS));
   const qty_dec = useSelector((state) => getDecimalValue(state, code, QTY_DECIMALS));

   const onTradingRulesDropDownChange = (e) => setTradingRules(e.target.value);

   useEffect(() => {
      if (price_dec !== undefined) {
         setPriceStep(GetMinStep(price_dec));
      }
      }, [price_dec]);
      
   useEffect(() => {
      if (qty_dec !== undefined) {
         setQtyStep(GetMinStep(qty_dec));
      }
   }, [qty_dec]);
   
   // Disabled fields state
   const [disabledFields, setDisabledFields] = useState({});
   
   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onInstrumentDropDownChange = (e) => setCode(e.target.value); 
   const onStatusDropDownChange = (e) => setStatus(e.target.value);
   const onMarketDropDownChange = (e) => setMarket(e.target.value);
   const onCurrencyDropDownChange = (e) => setCurrency(e.target.value);
   const onBaseDropDownChange = (e) => setBase(e.target.value);
   const onCancelAllOrdersDropDownChange = (e) => setCancelAllOrders(e.target.value);
   const onBuyTraderDropDownChange = (e) => setBuyTrader(e.target.value);
   const onSellTraderDropDownChange = (e) => setSellTrader(e.target.value);
   const onBuyTradingAccountDropDownChange = (e) => setBuyTradingAccount(e.target.value);
   const onSellTradingAccountDropDownChange = (e) => setSellTradingAccount(e.target.value);
   const onUpdateStatsDropDownChange = (e) => setUpdateStats(e.target.value);

   function ResetValues() {
      setDescription('');
      setMarket(DROPDOWN_LIST_NONE);
      setBase(DROPDOWN_LIST_NONE);
      setCurrency(DROPDOWN_LIST_NONE);
      setTradingRules(DROPDOWN_LIST_NONE);
      setPriceDecimals('');
      setQtyDecimals('');
      setIssueQty('');
      setReference('');
      setPrevious('');
      setOpen('');
      setClose('');
   };
   
   // helper to set disabled fields depending on type
   const updateDisabledFields = (instrumentType) => {
      switch (Number(instrumentType)) {
         case INSTRUMENT_TYPE_CRYPTO:
            setDisabledFields({
            market: false,
            base: false,
            priceDecimals: false,
            qtyDecimals: false,
            issueQty: false,
            reference: false,
            previous: false,
            currency: false,
            open: false,
            close: false,
            trading_rules: false,
            status: false,
            });
            break;

         case INSTRUMENT_TYPE_EQUITY:
         case INSTRUMENT_TYPE_WARRANT:
         case INSTRUMENT_TYPE_ETF:
         case INSTRUMENT_TYPE_FUTURES:
         case INSTRUMENT_TYPE_INDEX:
         case INSTRUMENT_TYPE_BONDS:
            setDisabledFields({
            market: false,
            base: true,
            priceDecimals: false,
            qtyDecimals: false,
            issueQty: false,
            currency: false,
            reference: false,
            previous: false,
            open: false,
            close: false,
            trading_rules: false,
            status: false,
            });
            break;

         case INSTRUMENT_TYPE_CURRENCY:
         case INSTRUMENT_TYPE_CRYPTO_CURRENCY:
            setDisabledFields({
            market: true,
            base: true,
            priceDecimals: false,
            qtyDecimals: true,
            reference: true,
            issueQty: true,
            previous: true,
            currency: true,
            open: true,
            close: true,
            trading_rules: true,
            status: true,
            });
            break;

         default:
            setDisabledFields({});
            break;
      }
   };

   // your dropdown handler just sets type + updates disabled fields
   const onTypeDropDownChange = (e) => {
      const value = e.target.value;
      setType(value);
      ResetValues();
      updateDisabledFields(value);
   };

   // run once when type is set (from rowData or elsewhere)
   useEffect(() => {
      if (type) {
         updateDisabledFields(type);
      }
   }, [type]);


   const onInstrumentModifyDropDownChange = (e) => {
      ResetValues()
      setCode(e.target.value);
      setType(INSTRUMENT_TYPE_NAME_EQUITY);
      setStatus(SUSPEND);
   };

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) {
         handleStatusConfirmationSubmit(item);
         onClose(); 
      }
   };
   
   useEffect(() => {
      if (rowData?.i_type) {
         setType(ConvertToInstrumentTypeId(rowData.i_type));
      }
      
      if (rowData?.market) {
         setMarket(rowData.market);
      }
      
      if (rowData?.cur) {
         setCurrency(rowData.cur);
      }

      if (rowData?.base) {
         setBase(rowData.base);
      }
      
      if (rowData?.status) {
         setStatus(ConvertStatusFromNameToId(rowData.status));
      }

      if (rowData?.p_type) {
         setType(ConvertToInstrumentTypeId(rowData?.p_type));
      }
   }, [rowData]);
   
   const handleStatusConfirmationSubmit = (submitItem) => {
      const basePayload = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_INSTRUMENT]: code,
      };

      // const resolvedStatus = status === SUSPENDED ? STATUS_SUSPEND : STATUS_ACTIVE;
      // console.log('canellAllOrders: ', cancelAllOrders, ', status: ', status, ', resolvedStatus: ', resolvedStatus);
      const dispatch = (type, payload) => DispatchTransactionEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, type, payload);

      switch (submitItem) {
         case ITEM_STATUS: {
            dispatch(EVENT_TYPE_INSTRUMENT_STATUS, {

            ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INSTRUMENT_CHANGE_STATUS,
               [JSON_KEY_WITHDRAW_ALL_ORDERS]: cancelAllOrders,
               [JSON_KEY_STATUS]: status,
            });
            break;
         }         
         
         case ITEM_CANCEL: {
            dispatch(EVENT_TYPE_INSTRUMENT_CANCEL_ALL_ORDERS, {
               ...basePayload,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_INSTRUMENT_CANCEL_ALL_ORDERS,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: cancelAllOrders,
            });
            break;
         }

         case ITEM_CREATE: {
            const payload = {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INSTRUMENT_CREATE,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_INSTRUMENT_TYPE]: Number(type),
               [JSON_KEY_PRICE_DECIMALS]: Number(priceDecimals),
               [JSON_KEY_TRADING_RULES]: tradingRules,
               [JSON_KEY_STATUS]: status,
            };


            if (Number(type) !== INSTRUMENT_TYPE_CURRENCY) {
               payload[JSON_KEY_MARKET] = market;
               payload[JSON_KEY_CURRENCY] = currency;
               payload[JSON_KEY_QTY_DECIMALS] = Number(qtyDecimals);
               
               if (reference || reference === 0) {
                  payload[JSON_KEY_REFERENCE_PRICE] = Number(To64BitIntFromPriceString(reference, priceDecimals));
               }
      
               if (previous || previous === 0) {
                  payload[JSON_KEY_PREVIOUS_PRICE] = Number(To64BitIntFromPriceString(previous, priceDecimals));
               }
               
               if (open || open === 0) {
                  payload[JSON_KEY_OPEN] = Number(To64BitIntFromPriceString(open, priceDecimals));
               }
               
               if (close || close === 0) {
                  payload[JSON_KEY_CLOSE] = Number(To64BitIntFromPriceString(close, priceDecimals));
               }

               if (issueQty || issueQty === 0) {
                  payload[JSON_KEY_ISSUE_QTY] = Number(To64BitIntFromPriceString(issueQty, 0));
               }               
            } 
               
            if (type === INSTRUMENT_TYPE_CRYPTO) {
               payload[JSON_KEY_BASE] = base;
            }

            dispatch(EVENT_TYPE_INSTRUMENT_CREATE, payload);

            break;
         }

         case ITEM_MODIFY: {
            const payload = {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INSTRUMENT_MODIFY,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_INSTRUMENT_TYPE]: Number(type),
               [JSON_KEY_PRICE_DECIMALS]: Number(priceDecimals),
               [JSON_KEY_STATUS]: status,
               [JSON_KEY_TRADING_RULES]: tradingRules,
               [JSON_KEY_WITHDRAW_ALL_ORDERS]: cancelAllOrders,
            };


            if (type !== INSTRUMENT_TYPE_CURRENCY) {
               payload[JSON_KEY_MARKET] = market;
               payload[JSON_KEY_CURRENCY] = currency;
               payload[JSON_KEY_QTY_DECIMALS] = Number(qtyDecimals);
               if (reference || reference === 0) {
                  payload[JSON_KEY_REFERENCE_PRICE] = Number(To64BitIntFromPriceString(reference, priceDecimals));
               }
      
               if (previous || previous === 0) {
                  payload[JSON_KEY_PREVIOUS_PRICE] = Number(To64BitIntFromPriceString(previous, priceDecimals));
               }
               
               if (open || open === 0) {
                  payload[JSON_KEY_OPEN] = Number(To64BitIntFromPriceString(open, priceDecimals));
               }
               
               if (close || close === 0) {
                  payload[JSON_KEY_CLOSE] = Number(To64BitIntFromPriceString(close, priceDecimals));
               }
               
               if (issueQty || issueQty === 0) {
                  payload[JSON_KEY_ISSUE_QTY] = Number(To64BitIntFromPriceString(issueQty, 0));
               }    
            } 
               
            if (type === INSTRUMENT_TYPE_CRYPTO) {
               payload[JSON_KEY_BASE] = base;
            }

            dispatch(EVENT_TYPE_INSTRUMENT_MODIFY, payload);

            break;
         }

         case ITEM_TRADE_ENTRY: {
            const payload = {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADE_ENTRY,
               [JSON_KEY_BUY_USER]: buyTrader,
               [JSON_KEY_BUY_TRADING_ACCOUNT]: buyTradingAccount,
               [JSON_KEY_SELL_USER]: sellTrader,
               [JSON_KEY_SELL_TRADING_ACCOUNT]: sellTradingAccount,
            };

            if (price) {
               payload[JSON_KEY_PRICE] = Number(To64BitIntFromPriceString(price, priceDecimals));
            }

            if (quantity) {
               payload[JSON_KEY_QTY] = Number(To64BitIntFromPriceString(quantity, qtyDecimals));
            }
         
            payload[JSON_KEY_STATUS] = status;
            payload[JSON_KEY_UPDATE_STATS] = updateStats;
      
            dispatch(EVENT_TYPE_INSTRUMENT_CREATE, payload);

            break;
         }

         default:
            console.warn('InstrumentsAdminForm: unknown submit item', submitItem);
      }
   };

   const handleTradeEntrySubmit = () => {
      // add checks
      const error = ValidateTradeEntry();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Trade Entry",
         text: `Trade Entry for instrument ${code}, buy trader: ${buyTrader}, sell trader: ${sellTrader}, buy account: ${buyTradingAccount}, sell account: ${sellTradingAccount}, price: ${price}, quantity: ${quantity}`,
         item: ITEM_TRADE_ENTRY,
      });
   };

   const ValidateTradeEntry = () => {
      if (code === 'None') return "Instrument is missing";
      if (!price) return "Price is missing";
      if (!quantity) return "Quantity is missing";
      if (buyTrader === 'None') return "Buy Trader is missing";
      if (sellTrader === 'None') return "Sell Trader is missing";
      if (buyTradingAccount === 'None') return "Buy Account is missing";
      if (sellTradingAccount === 'None') return "Sell Account is missing";
      return null;
   };
      
   const handleWithdrawSubmit = () => {
      // validate
      if (cancelAllOrders === NO) return ShowError("Cancel All Orders must be YES");

      ConfirmConfirmCancelAndSubmit({
         title: "Instrument Cancel All Orders",
         text: `Do you want to cancel all orders on the Instrument ${code}`,
         item: ITEM_CANCEL,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });
      
      onClose(); // your modal close function

      // if (cancelAllOrders === NO) {
      //     ShowError("Need to set Cancal All Orders to Yes")
      // }
      // else {
      //    ConfirmAndSubmit({
      //       title: "Instrument Cancel All Orders",
      //       text: `Cancelling all orders for instrument ${code}`,
      //       item: ITEM_CANCEL,
      //    });
      // }
   };
      
   const handleStatusSubmit = () => {
      ConfirmConfirmCancelAndSubmit({
         title: "Instrument Status Change",
         text: `Setting instrument ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function

      // ConfirmAndSubmit({
      //    title: "Instrument Status Change",
      //    text: `Setting instrument ${code} to ${ConvertStatus(status)}`,
      //    item: ITEM_STATUS,
      // });
   };

   const ValidateFields = () => {
      if (!code) return "Instrument code is missing";
      if (!description) return "Description is missing";
      if (!type) return "Type is missing";
      if (!market) return "Market is missing";
      if (!priceDecimals) return "Price decimals is missing";
      if (!status) return "Status is missing";

      // console.log('type: ', type, ', base: ', base, ', currency: ', currency);
      if (type === INSTRUMENT_TYPE_CRYPTO) {
         if (!base) return "Base is missing";
      } else {
         if (base !== DROPDOWN_LIST_NONE) return "Base is not allowed for non-Crypto instruments";
      }

      if (type !== INSTRUMENT_TYPE_CURRENCY) {
         if (qtyDecimals === 'undefined') return "Quantity  decimals is missing";
      } 

      return null;
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create Instrument",
         text: `Creating new instrument: ${code}`,
         item: ITEM_CREATE,
      });

      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify Instrument",
         text: `Modifying instrument: ${code}`,
         item: ITEM_MODIFY,
      });

      onClose(); // your modal close function
   };

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(ConvertStatusFromNameToId(SUSPEND));
      }
   }, [selectedTabIndex, rowData]);
   
   return (
      <div className="admin-large-form">
         <div className="admin-large-tabs">
         <h2 className="center-heading">Instrument Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-large-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Instrument</Tab>
               <Tab>Create Instrument</Tab>
               <Tab>Cancel All Orders</Tab>
               <Tab>Trade Entry</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, instrumentOptions, onInstrumentDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               
               <div className="top">
                  {RenderDropdown(
                     "Cancel All Orders",
                     status === STATUS_ACTIVE ? NO : cancelAllOrders, // force NO if Active
                     yesNoOptions,
                     status === STATUS_ACTIVE ? () => {} : onCancelAllOrdersDropDownChange, // ignore changes if Active
                     status === STATUS_ACTIVE // disable dropdown if Active
                  )}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify Instrument */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, allInstrumentsOptions, onInstrumentModifyDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>

               <div>
                  <InputMediumField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Market", market, marketOptions, onMarketDropDownChange, disabledFields.market)}
               </div>

               <div className="top">
                  {RenderDropdown("Base", base, currencyOptions, onBaseDropDownChange, disabledFields.base)}
               </div>

               <div>
                  <InputMediumField label="Issue Quantity" value={issueQty} onChange={setIssueQty} readOnly={disabledFields.issueQty} type="number"/>
               </div>
               
               <div className="top">
                  {RenderDropdown("Currency", currency, currencyOptions, onCurrencyDropDownChange, disabledFields.currency)}
               </div>

               <div>
                  <InputMediumField label="Price Decimals" value={priceDecimals} onChange={setPriceDecimals} type="number" />
               </div>

               <div>
                  <InputMediumField label="Quantity Decimals" value={qtyDecimals} onChange={setQtyDecimals} readOnly={disabledFields.qtyDecimals} type="number"/>
               </div>
               
               <div>
                  <InputMediumField label="Reference" value={reference} onChange={setReference} type="number" readOnly={disabledFields.reference} />
               </div>

               <div>
                  <InputMediumField label="Previous" value={previous} onChange={setPrevious} type="number" readOnly={disabledFields.previous} />
               </div>
               
               <div>
                  <InputMediumField label="Open" value={open} onChange={setOpen} type="number" readOnly={disabledFields.open} />
               </div>
               
               <div>
                  <InputMediumField label="Close" value={close} onChange={setClose} type="number" readOnly={disabledFields.close} />
               </div>

               <div className="top">
                  {RenderDropdown("Trading Rules", tradingRules, tradingRulesOptions, onTradingRulesDropDownChange, disabledFields.trading_rules)}
               </div>

               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange)}
               </div>
               */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create Instrument */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputMediumField label="Code" value={code} onChange={setCode} />
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>

               <div>
                  <InputMediumField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Market", market, marketOptions, onMarketDropDownChange, disabledFields.market)}
               </div>

               <div className="top">
                  {RenderDropdown("Base", base, currencyOptions, onBaseDropDownChange, disabledFields.base)}
               </div>

               <div>
                  <InputMediumField label="Issue Quantity" value={issueQty} onChange={setIssueQty} readOnly={disabledFields.issueQty} type="number"/>
               </div>

               <div className="top">
                  {RenderDropdown("Currency", currency, currencyOptions, onCurrencyDropDownChange, disabledFields.currency)}
               </div>

               <div>
                  <InputMediumField label="Price Decimals" value={priceDecimals} onChange={setPriceDecimals} type="number" />
               </div>

               <div>
                  <InputMediumField label="Quantity Decimals" value={qtyDecimals} onChange={setQtyDecimals} readOnly={disabledFields.qtyDecimals} type="number"/>
               </div>
               
               <div>
                  <InputMediumField label="Reference" value={reference} onChange={setReference} type="number" readOnly={disabledFields.reference} />
               </div>

               <div>
                  <InputMediumField label="Previous" value={previous} onChange={setPrevious} type="number" readOnly={disabledFields.previous} />
               </div>
               
               <div>
                  <InputMediumField label="Open" value={open} onChange={setOpen} type="number" readOnly={disabledFields.open} />
               </div>
               
               <div>
                  <InputMediumField label="Close" value={close} onChange={setClose} type="number" readOnly={disabledFields.close} />
               </div>

               <div className="top">
                  {RenderDropdown("Trading Rules", tradingRules, tradingRulesOptions, onTradingRulesDropDownChange, disabledFields.trading_rules)}
               </div>
               
               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div> */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 4: Cancel all orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleWithdrawSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, instrumentOptions, onInstrumentDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange)}
               </div>
               {/*  */}
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>


            {/* Tab 5: trade entry */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleTradeEntrySubmit)}>
               <div className="top">
                  {RenderDropdown("Instrument", code, instrumentOptions, onInstrumentDropDownChange)}
               </div>

               <div>
                  <InputMediumField label="Price" value={price} onChange={setPrice} type="number" min={price_step} step={price_step} />
               </div>

               <div>
                  <InputMediumField label="Quantity" value={quantity} onChange={setQuantity} type="number" min={qty_step} step={qty_step} />
               </div>

               <div className="top">
                  {RenderDropdown("Buy Trader", buyTrader, dropDownTradingUsersData, onBuyTraderDropDownChange, disabledFields.currency)}
               </div>

               <div className="top">
                  {RenderDropdown("Buy Account", buyTradingAccount, dropDownTradingAccountsData, onBuyTradingAccountDropDownChange, disabledFields.currency)}
               </div>

               <div className="top">
                  {RenderDropdown("Sell Trader", sellTrader, dropDownTradingUsersData, onSellTraderDropDownChange, disabledFields.currency)}
               </div>

               <div className="top">
                  {RenderDropdown("Sell Account", sellTradingAccount, dropDownTradingAccountsData, onSellTradingAccountDropDownChange, disabledFields.currency)}
               </div>

               <div className="top">
                  {RenderDropdown("Update Market Statistics", updateStats, yesNoOptions, onUpdateStatsDropDownChange)}
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default InstrumentsAdminForm;
